export default __webpack_public_path__ + "static/media/verdana.beb04533.ttf";